'use client';

import { createContext, ReactNode, useRef } from 'react';

import { EventLogger } from '@kouzoh/client-event-logger';
import { makeEventLogger } from './eventLogger';

export const EventLoggerContext = createContext<EventLogger | null>(null);

type Props = {
  children: ReactNode;
};

export const EventLogProvider = ({ children }: Props) => {
  const logger = useRef(makeEventLogger());
  return (
    <EventLoggerContext.Provider value={logger.current}>{children}</EventLoggerContext.Provider>
  );
};
